import React, { useState, ChangeEvent } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { toast } from 'react-toastify';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { Form } from '@unform/web';
import { useHistory } from 'react-router';
import { signin, SignInParams } from '@bforms-web/common';
import { FORGET_PASSWORD_ROUTE, PATIENTS_ROUTE } from '../../constants';
import { useStyles } from './styles';

interface Token {
  access_token: string;
}

export default function SignIn() {
  const { push } = useHistory();
  const classes = useStyles();
  const [values, setValues] = useState<SignInParams>({
    username: '',
    password: '',
  });

  const handleChange = (prop: keyof SignInParams) => (
    event: ChangeEvent<HTMLInputElement>,
  ): void => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleSubmit = () => {
    async function runAsync() {
      try {
        const token = JSON.stringify(await signin.execute(values));
        const parsedToken: Token = JSON.parse(token);
        localStorage.setItem('admToken', parsedToken.access_token);

        window.location.href = PATIENTS_ROUTE;
      } catch (err) {
        localStorage.setItem('admToken', '');
        toast.warn('Login ou senha incorretos');
      }
    }
    runAsync();
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
      <img src="logo-signin.png" alt="bCare | Funcional" className={classes.logo}/>

        <Form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            value={values.username}
            onChange={handleChange('username')}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Seu E-mail"
            autoComplete="email"
            autoFocus
          />
          <TextField
            value={values.password}
            onChange={handleChange('password')}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Sua senha"
            type="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Entrar
          </Button>
          <Grid container>
            <Grid item xs>
              <Button
                color="primary"
                onClick={() => {
                  push(FORGET_PASSWORD_ROUTE);
                }}
              >
                {'Esqueceu sua senha?'}
              </Button>
            </Grid>
          </Grid>
        </Form>
      </div>

      <Box mt={8}>
        <Typography variant="body2" align="center" className={classes.span}>
          © 2026{' '}
          <a href="https://www.bcare.com.br" target="_blank" rel="noreferrer">
            bCare
          </a>
          . Todos os direitos reservados.
        </Typography>
      </Box>
    </Container>
  );
}
